import { authorizeGetRequest, authorizePutRequest, BASE_URL } from "api";
import { IPaginatedResponse, IApiResponse, IError } from "models";
import { ICancelTripRequest, ITripRequest } from "models/tripRequest";
import axios from "axios";

export const tripRequestsApi = (
  page: number,
  perPage: number,
  search: string,
  status: string = "all",
  date: string = ""
) => {
  search = search.replace("+", "%2B");
  let url = `trip-requests?page=${page}&per_page=${perPage}&search=${search}`;
  if (status && status !== "all") {
    url += `&status=${status}`;
  }
  if (date) {
    url += `&date=${date}`;
  }
  return authorizeGetRequest<IPaginatedResponse<ITripRequest>>(url);
};

export const cancelTripRequestByIdApi = (
  id: string,
  input: ICancelTripRequest
) => {
  return authorizePutRequest<any>(`trip-requests/${id}/cancel/admin`, input);
};

export interface IStartTripRequestInput {
  latitude: number;
  longitude: number;
  accuracy?: number;
  speed?: number;
  local_timestamp: string;
  heading?: number;
}

export const startTripRequestByIdApi = (
  id: string,
  locationData: IStartTripRequestInput
): Promise<IApiResponse<any>> => {
  return new Promise((resolve) => {
    axios
      .post(`${BASE_URL}trip-requests/${id}/start`, locationData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => resolve({ data: response.data }))
      .catch((error) => {
        // Don't trigger logout on auth errors for this endpoint
        // Just return the error without redirecting
        const errorResponse: IError = {
          errors: error?.response?.data?.detail
            ? (Array.isArray(error.response.data.detail)
              ? error.response.data.detail.map((item: any) =>
                `${item.loc?.[item.loc.length - 1]}: ${item.msg}` || item.msg
              )
              : [error.response.data.detail])
            : error?.response?.data?.message
              ? (Array.isArray(error.response.data.message)
                ? error.response.data.message
                : [error.response.data.message])
              : typeof error?.response?.data === "string"
                ? [error.response.data]
                : ["Failed to start trip request"],
          message: error?.response?.data?.detail
            ? (typeof error.response.data.detail === "string"
              ? error.response.data.detail
              : error.response.data.detail.map((item: any) => item.msg).join(", "))
            : error?.response?.data?.message
              ? (typeof error.response.data.message === "string"
                ? error.response.data.message
                : error.response.data.message.join(", "))
              : typeof error?.response?.data === "string"
                ? error.response.data
                : "Failed to start trip request",
          status: error?.response?.status || 400,
        };
        resolve({ error: errorResponse });
      });
  });
};
